var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPoolIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6422 13.3C13.1058 13.3 14.2922 12.1136 14.2922 10.65C14.2922 9.18645 13.1058 8 11.6422 8C10.1786 8 8.99219 9.18645 8.99219 10.65C8.99219 12.1136 10.1786 13.3 11.6422 13.3Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.358 13.3C22.8216 13.3 24.008 12.1136 24.008 10.65C24.008 9.18645 22.8216 8 21.358 8C19.8945 8 18.708 9.18645 18.708 10.65C18.708 12.1136 19.8945 13.3 21.358 13.3Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6417 24.0002C13.1053 24.0002 14.2917 22.8138 14.2917 21.3502C14.2917 19.8866 13.1053 18.7002 11.6417 18.7002C10.1782 18.7002 8.9917 19.8866 8.9917 21.3502C8.9917 22.8138 10.1782 24.0002 11.6417 24.0002Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3585 24.0002C22.8221 24.0002 24.0085 22.8138 24.0085 21.3502C24.0085 19.8866 22.8221 18.7002 21.3585 18.7002C19.8949 18.7002 18.7085 19.8866 18.7085 21.3502C18.7085 22.8138 19.8949 24.0002 21.3585 24.0002Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoolIcon);
export default __webpack_public_path__ + "static/media/pool-icon.615e57a2ad2929f526af2f96754c9100.svg";
export { ForwardRef as ReactComponent };